import validate from "/srv/sarvban_front/node_modules/nuxt/dist/pages/runtime/validate.js";
import broken_45link_45tracker_45global from "/srv/sarvban_front/middleware/broken-link-tracker.global.ts";
import manifest_45route_45rule from "/srv/sarvban_front/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  broken_45link_45tracker_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-my-sarvban": () => import("/srv/sarvban_front/middleware/auth-my-sarvban.js"),
  auth: () => import("/srv/sarvban_front/middleware/auth.js")
}